import { render, staticRenderFns } from "./SiInputTextarea.vue?vue&type=template&id=6149e4d0&scoped=true&lang=html&"
import script from "./SiInputTextarea.vue?vue&type=script&lang=js&"
export * from "./SiInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149e4d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
